// some functions are shared with the backend and thus need to be imported in both systems. This file does exactly that

function createMap(depictionDic, wde, filename){

  const dimensionId = wde?.wallDimensionID != null ? String(wde.wallDimensionID) : null;
  function isEmptyRowFunc(wde, y) {
    let numberEmptySpot = 0;
    for (let ese of wde.emptySpots){
      if ((ese.registerPositionY === y) && (!ese.deleted)) {
        numberEmptySpot += 1;
      }
    }
    if (wde.registerType === 0 && (y % 2) === 0) {
      numberEmptySpot += 1;
    }
    if (numberEmptySpot === wde.columns) {
      return true;
    }
    return false;
  }
  function isEmptyFunc(wde, x, y) {
    for (let ese of wde.emptySpots){
      if ((ese.registerPositionY === y) && (ese.registerPositionX === x) && (!ese.deleted)) {
        return true;
      }
    }
    return false;
  }
  function hasEmptySpotsForSubtraction(wde, x, y) {
    let numEmptySpots = 0;
    for (let ese of wde.emptySpots) {
      if (ese.registerPositionY === y && !ese.deleted) {
        if (wde.registerDirectionX === 1) {
          if (ese.registerPositionX > x) {
            numEmptySpots += 1;
          }
        } else {
          if (ese.registerPositionX < x) {
            numEmptySpots += 1;
          }
        }
      }
    }
    return numEmptySpots;
  }

  function isOdd(num) { return num % 2;}
  var label = ""
  var getLabel = function(rowNumber, colNumber, depictionIDs, row, col){
    const dimensionFragment = dimensionId !== null ? `, "dimensionId": "${dimensionId}"` : "";
    if (rowNumber !== -1 && colNumber !== -1){
      label = "{\"Reg\": \"" + rowNumber + "\", \"No\": \"" + colNumber + "\", \"x\": \"" + col.toString() + "\", \"y\": \"" + row.toString() + "\"" + dimensionFragment + " , \"Depiction\": " + JSON.stringify(depictionIDs)  + "}"
    } else {
      label =  "{\"Reg\": \"-1\", \"No\": \"-1\", \"x\": \"" + col.toString() + "\", \"y\": \"" + row.toString() + "\"" + dimensionFragment + " ,\"Depiction\": []}"
    }
    return label
  }
  function addRhombus(row, col, rows, cols, height, width, rowNumber, colNumber){
    var depictionIDs = getDepictionIDs(rowNumber, colNumber);
    if (depictionIDs.length === 0){
    }
    var heightRhomb = 0;
    heightRhomb = (rows > 1 ? (height * 2) / (rows - 1) : (height * 2) / (1)) * (((row) / 2));
    var heightrow = rows > 1 ? (height * 2) / (rows - 1) : (height * 2) / (1);
    var newPath = "";
    if (isOdd(row) === 0){
      newPath = "M" + (wde.registerPositionX + ((width * ((2 * col) - 1)) / ((2 * cols) - 2))) + ", " + (wde.registerPositionY + ((row === 1) ? 0 : (heightRhomb - heightrow))) + "L" + (wde.registerPositionX + ((col === cols) ? width : ((((col * width) / ((cols) - 1)))))) + ", " + (wde.registerPositionY + ((row === 1) ? 0 : (heightRhomb - heightrow + (heightrow / 2)))) + "L" + (wde.registerPositionX + (((col) / ((cols) - 1) * width) - ((((1) / ((cols) - 1) * width)) / 2))) + ", " + (wde.registerPositionY + ((row === rows) ? height : (heightRhomb))) + "L" + (wde.registerPositionX + ((((col + 1) / ((cols) - 1) * width)) - ((((1) / ((cols) - 1) * width)) * 2))) + ", " + (wde.registerPositionY + ((heightrow / 2) + heightRhomb - heightrow)) + "L" + (wde.registerPositionX + (((col) / ((cols) - 1) * width) - ((((1) / ((cols) - 1) * width)) / 2))) + ", " + (wde.registerPositionY + (heightRhomb - heightrow)) + "Z";
    } else {
      newPath = "M" + (wde.registerPositionX + ((col === 1) ? 0 : (((col - 1) / ((cols) - 1) * width)))) + ", " + (wde.registerPositionY + ((row === 1) ? 0 : (heightRhomb - heightrow))) + "L" + (wde.registerPositionX + ((col === cols) ? width : ((((width * (2 * col - 1)) / ((2 * cols) - 2)))))) + ", " + (wde.registerPositionY + ((row === 1) ? 0 : (heightRhomb - heightrow + (heightrow / 2)))) + "L" + (wde.registerPositionX + ((col === 1) ? 0 : (((col - 1) / ((cols) - 1) * width)))) + ", " + (wde.registerPositionY + ((row === rows) ? height : (heightRhomb))) + "L" + (wde.registerPositionX + ((col === 1) ? 0 : ((((col) / ((cols) - 1) * width)) - ((((1) / ((cols) - 1) * width))) - ((((1) / ((cols) - 1) * width) / 2))))) + ", " + (wde.registerPositionY + ((heightrow / 2) + heightRhomb - heightrow)) + "L" + (wde.registerPositionX + ((col === 1) ? 0 : (((col - 1) / ((cols) - 1) * width)))) + ", " + (wde.registerPositionY + ((row === 1) ? 0 : (heightRhomb - heightrow))) + "Z";
    }
    var annotation = {
      "@context": "http://www.w3.org/ns/anno.jsonld",
      "id": "x. " + row + ", y. " + col,
      "type": "Annotation",
      "body": [
        {
          "type": "TextualBody",
          "value": getLabel(rowNumber, colNumber, depictionIDs, row, col),
          "id": "x. " + row + ", y. " + col,
          "image": filename
        }
      ],
      "target": {
        "selector": {
          "type": "SvgSelector",
          "conformsTo": "http://www.w3.org/TR/media-frags/",
          "value": "<svg><path d=\"" + newPath + "\"></path></svg>"
        },
        "source": filename
      }
    }
    return annotation;
  }
  function addRect(row, col, rows, cols, height, width, rowNumber, colNumber){
    var depictionIDs = getDepictionIDs(rowNumber, colNumber);
    var newPath = "";
    newPath = "xywh=pixel:" + (wde.registerPositionX + (((width / cols) * (col - 1)))) + ", " + (wde.registerPositionY + (((height / rows) * (row - 1)))) + ", " + (width / cols) + ", " + (height / rows);
    var annotation = {
      "@context": "http://www.w3.org/ns/anno.jsonld",
      "id": "x. " + row + ", y. " + col,
      "type": "Annotation",
      "body": [
        {
          "type": "TextualBody",
          "value": getLabel(rowNumber, colNumber, depictionIDs, row, col),
          "id": "x. " + row + ", y. " + col,
          "image": filename
        }
      ],
      "target": {
        "selector": {
          "type": "FragmentSelector",
          "conformsTo": "http://www.w3.org/TR/media-frags/",
          "value": newPath
        },
        "source": filename
      }
    }
    return annotation;
  }
  function getDepictionIDs(rowNumber, colNumber){
    var depictionIDs = null
    if (rowNumber in depictionDic){
      if (colNumber in depictionDic[rowNumber]){
        depictionIDs = depictionDic[rowNumber][colNumber]
      } else {
        depictionIDs = []
      }
    } else {
      depictionIDs = []
    }
    return depictionIDs
  }
  var annotations = [];
  // this for loop iterates over the rows. It beins fom bottom to top or top to bottom, depending on the direction
  var registerOffset = wde.registerOffset ? wde.registerOffset : 0;
  var registerCounter = 1 + registerOffset;
  var rowStart = (wde.registerDirectionY === 0) ? 1 : wde.registers;
  var rowEnd = (wde.registerDirectionY === 0) ? wde.registers + 1 : 0;
  var rowStep = (wde.registerDirectionY === 0) ? 1 : -1;
  var isEmptyRow = false;
  for (var j = rowStart; j !== rowEnd; j += rowStep) {
    if (isEmptyRowFunc(wde, j)){
      isEmptyRow = true;
    } else {
      isEmptyRow = false;
    }
    // this for loop iterates over the columns. It beins fom left to right or right to left, depending on the direction.
    var columnOffset = wde.columnOffset ? wde.columnOffset : 0;
    var numberCounter = 1 + columnOffset;
    var colStart = (wde.registerDirectionX === 0) ? 1 : wde.columns;
    var colEnd = (wde.registerDirectionX === 0) ? wde.columns + 1 : 0;
    var colStep = (wde.registerDirectionX === 0) ? 1 : -1;
    var isRect = wde.registerType === 0 ? false: true;
    for (var i = colStart; i !== colEnd; i += colStep) {
      var isEmpty = isEmptyFunc(wde, i, j);
          var annotationObject = {};
          if (isRect){
              annotationObject = addRect(j,i,wde.registers, wde.columns, wde.registerPositionH, wde.registerPositionW, isEmpty? -1: (registerCounter), isEmpty? -1: (numberCounter))
          } else {
            if (!((i === wde.columns) && (isOdd(j) === 0))){
              annotationObject = addRhombus(j,i,wde.registers, wde.columns, wde.registerPositionH, wde.registerPositionW, isEmpty? -1: registerCounter, isEmpty? -1: (numberCounter))
            } else {
              // we don't want the rhombus on the first row to be counted, that is why we set isEmpty to true. it prevents numberCounter from increasing
              isEmpty = true
            }
          }
          if (Object.keys(annotationObject).length > 0){
            annotations.push(annotationObject);
          }
      if (!isEmpty){
        numberCounter += 1;
      }
    }
    if (!isEmptyRow){
      registerCounter += 1
    }
  }
  console.log("create map results for ", wde, annotations)
  return annotations;
}

function parsePathData(pathData) {
  // Leerzeichen nach Kommas entfernen und Z-Befehl ignorieren
  const cleaned = pathData.replace(/,\s+/g, ',').replace(/Z/gi, '');
  const matches = [...cleaned.matchAll(/([ML])\s*(-?[\d.]+),\s*(-?[\d.]+)/g)];

  return matches.map(match => ({
    x: parseFloat(match[2]),
    y: parseFloat(match[3])
  }));
}
function  parseSvgPath(d) {
      // Parsen des 'd'-Attributs eines Pfads in ein Polygon
      const commands = d.match(/[a-df-z][^a-df-z]*/ig);
      let currentPoint = [0, 0];
      const points = [];

      commands.forEach(command => {
        const type = command[0];
        const coords = command.slice(1).trim().split(/[\s,]+/).map(Number);

        switch (type) {
          case 'M': // Move to absolute
            currentPoint = [coords[0], coords[1]];
            points.push(currentPoint);
            break;
          case 'L': // Line to absolute
            currentPoint = [coords[0], coords[1]];
            points.push(currentPoint);
            break;
          case 'z':
          case 'Z': // Close path
            points.push(points[0]);
            break;
          default:
            console.warn(`Unsupported SVG path command: ${type}`);
        }
      });

      return points;
    }

function parseSvgSelector(value) {
  // Parse den SVG-Selector-Wert, um die Polygone zu bekommen
  const parser = new DOMParser();
  const doc = parser.parseFromString(value, "image/svg+xml");
  const paths = Array.from(doc.querySelectorAll("path"));
  return paths.map(path => parseSvgPath(path.getAttribute("d")));
}
function downloadCanvas(canvas, filename) {
  const link = document.createElement('a');
  link.download = filename;
  link.href = canvas.toDataURL('image/jpeg', 0.9); // Oder 'image/png'
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
async function buildWallCanvas(registerPoints, canvas, width, height, meshName, dimensions, relatedDepictions, setRegisterShaderIndex, colocodeReg, putInIcoDepictionShaderDic, putInDepictionShaderDic, progress, context, getCachedIIIFImage, setCachedIIIFImage, sessionID){
  const promises = [];
  const wallImages = []; // Array for generated preview images of paintings
  const wallNumber = parseInt(meshName, 10);
  const getCachedImage = typeof getCachedIIIFImage === "function" ? getCachedIIIFImage : null;
  const setCachedImage = typeof setCachedIIIFImage === "function" ? setCachedIIIFImage : null;
  const relatedDepictionsById = new Map((relatedDepictions || []).map(depiction => [depiction.depictionID, depiction]));
  const annotationByDepictionId = new Map();
  const parsedW3cByAnnotationId = new Map();
  const selectorPathDataCache = new Map();
  const selectorPointsCache = new Map();
  const selectorPolygonCache = new Map();
  const masterPolygonByDepictionId = new Map();

  function buildOptimizedIIIFUrl({ annotation, reg, baseUrl }) {
    const annoPoints = getPointsFromSelector(annotation.target.selector.value);

    // Bounding Box der Annotation
    let xs = annoPoints.map(p => p.x);
    let ys = annoPoints.map(p => p.y);
    let minX = Math.floor(Math.min(...xs));
    let minY = Math.floor(Math.min(...ys));
    let width = Math.ceil(Math.max(...xs) - minX);
    let height = Math.ceil(Math.max(...ys) - minY);

    // Korrektur für negative Koordinaten (IIIF erlaubt nur ≥ 0)
    if (minX < 0) minX = 0;
    if (minY < 0) minY = 0;

    // Reg auswerten (Polygon oder Rechteck)
    const regPoints = getPointsFromSelector(reg.target.selector.value);
    if (regPoints.length === 0) throw new Error("Unbekannter Reg-Selektor");

    // Zielgröße bestimmen
    const regXs = regPoints.map(p => p.x);
    const regYs = regPoints.map(p => p.y);
    const tgtW = Math.max(...regXs) - Math.min(...regXs);
    const tgtH = Math.max(...regYs) - Math.min(...regYs);

    const scaleFactor = Math.min(tgtW / width, tgtH / height);

    // Zielauflösung
    const scaledW = Math.max(1, Math.round(width * scaleFactor));
    const scaledH = Math.max(1, Math.round(height * scaleFactor));

    // Finaler IIIF-URL
    const region = `${minX},${minY},${width},${height}`;
    const size = `${scaledW},${scaledH}`;
    const url = `${baseUrl}/${region}/${size}/0/default.jpg`;

    return {
      url,
      scale: scaleFactor,
      cropBox: { minX, minY, width, height },
      targetSize: { width: scaledW, height: scaledH }
    };
  }

function loadIIIFImage(url, sessionID) {
    const cached = getCachedImage ? getCachedImage(url) : null;
    if (cached) return Promise.resolve(cached);

    const loadPromise = fetch(url, {
      headers: sessionID ? { 'sessionid': sessionID } : {}
    })
    .then(response => {
      if (!response.ok) throw new Error(`IIIF image could not be loaded: ${url}`);
      return response.blob();
    })
    .then(blob => {
      return new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(blob);
        const img = new Image();
        img.crossOrigin = "Anonymous";

        img.onload = () => {
          URL.revokeObjectURL(objectUrl);
          if (setCachedImage) setCachedImage(url, img);
          resolve(img);
        };

        img.onerror = () => {
          URL.revokeObjectURL(objectUrl);
          if (setCachedImage) setCachedImage(url, null);
          reject(new Error(`IIIF image could not be loaded: ${url}`));
        };

        img.src = objectUrl;
      });
    })
    .catch(error => {
      if (setCachedImage) setCachedImage(url, null);
      throw error;
    });

    if (setCachedImage) setCachedImage(url, loadPromise);
    return loadPromise;
  }
  function getAnnotationById(depiction, annotoriousID) {
    let annotationById = annotationByDepictionId.get(depiction.depictionID);
    if (!annotationById) {
      annotationById = new Map((depiction.relatedAnnotationList || []).map(annotation => [annotation.annotoriousID, annotation]));
      annotationByDepictionId.set(depiction.depictionID, annotationById);
    }
    return annotationById.get(annotoriousID);
  }

  function getParsedW3c(annotation) {
    if (!annotation) return null;
    let w3c = parsedW3cByAnnotationId.get(annotation.annotoriousID);
    if (!w3c) {
      w3c = typeof annotation.w3c === "string" ? JSON.parse(annotation.w3c) : annotation.w3c;
      parsedW3cByAnnotationId.set(annotation.annotoriousID, w3c);
    }
    return w3c;
  }
  function fitsInside(polygonA, polygonB) {
    return polygonA.every(point => isPointInsidePolygon(point, polygonB));
  }
  function isPointInsidePolygon(point, polygon) {
    const [x, y] = point;
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i][0], yi = polygon[i][1];
      const xj = polygon[j][0], yj = polygon[j][1];

      const intersect = ((yi > y) !== (yj > y)) &&
                        (x < ((xj - xi) * (y - yi)) / ((yj - yi) + 1e-10) + xi);
      if (intersect) inside = !inside;
    }

    return inside;
  }
  function getPathDataFromSelector(selectorValue) {
    let pathData = selectorPathDataCache.get(selectorValue);
    if (pathData === undefined) {
      const match = selectorValue.match(/\sd=(["'])(.*?)\1/);
      pathData = match ? match[2] : null;
      selectorPathDataCache.set(selectorValue, pathData);
    }
    return pathData;
  }
  function findAxisAlignedExtremes(points, forceBoundingBox = false) {
    let minX, maxX, minY, maxY;
    let extremes;

    if (forceBoundingBox) {
      const xs = points.map(p => p[0]);
      const ys = points.map(p => p[1]);

      minX = Math.min(...xs);
      maxX = Math.max(...xs);
      minY = Math.min(...ys);
      maxY = Math.max(...ys);

      extremes = [
        [minX, minY], // left-top
        [maxX, minY], // right-top
        [maxX, maxY], // right-bottom
        [minX, maxY]  // left-bottom
      ];
    } else {
      let left   = points[0];
      let right  = points[0];
      let top    = points[0];
      let bottom = points[0];

      for (const [x, y] of points) {
        if (x < left[0])   left = [x, y];
        if (x > right[0])  right = [x, y];
        if (y < top[1])    top = [x, y];
        if (y > bottom[1]) bottom = [x, y];
      }

      minX = left[0];
      maxX = right[0];
      minY = top[1];
      maxY = bottom[1];

      extremes = [left, right, top, bottom];
    }

    return {
      extremes,
      width: maxX - minX,
      height: maxY - minY,
      minX: minX,
      minY: minY
    };
  }
  function findQuadrilateralExtremes(points, forceBoundingBox = false) {
  if (forceBoundingBox) {
    // Fallback für reine Rechtecke (z.B. registerType 0)
    return findAxisAlignedExtremes(points, true);
  }

  try {
    // 1. Array in OpenCV Matrix umwandeln
    const flatPoints = [];
    points.forEach(p => { flatPoints.push(p[0], p[1]); });
    const mat = cv.matFromArray(points.length, 1, cv.CV_32FC2, flatPoints);

    // 2. Konvexe Hülle bilden (glättet extreme Wackler der Handzeichnung)
    let hull = new cv.Mat();
    cv.convexHull(mat, hull);

    let perimeter = cv.arcLength(hull, true);
    let approx = new cv.Mat();

    // 3. Binäre Suche nach dem Epsilon, das exakt 4 Ecken liefert
    let minEps = 0.0;
    let maxEps = 0.2 * perimeter;
    let epsilon = 0.02 * perimeter;
    let bestApprox = [];

    for (let i = 0; i < 20; i++) {
      cv.approxPolyDP(hull, approx, epsilon, true);
      if (approx.rows === 4) {
        for (let j = 0; j < 4; j++) {
          bestApprox.push([approx.data32F[j * 2], approx.data32F[j * 2 + 1]]);
        }
        break; // Perfektes Viereck gefunden!
      } else if (approx.rows > 4) {
        minEps = epsilon; // Zu viele Ecken -> Polygon muss stärker vereinfacht werden
        epsilon = (epsilon + maxEps) / 2;
      } else {
        maxEps = epsilon; // Zu wenige Ecken -> Polygon muss genauer werden
        epsilon = (minEps + epsilon) / 2;
      }
    }

    mat.delete(); hull.delete(); approx.delete();

    // Fallback, falls die Annotation so wild ist, dass kein Viereck gefunden wurde
    if (bestApprox.length !== 4) {
      console.warn("approxPolyDP fand keine 4 Ecken, nutze Achsen-Fallback");
      return findAxisAlignedExtremes(points, false);
    }

// 4. Punkte exakt so sortieren, wie es targetExtremes erwartet: [Left, Right, Top, Bottom]
        let left   = bestApprox[0];
        let right  = bestApprox[0];
        let top    = bestApprox[0];
        let bottom = bestApprox[0];

        for (const [x, y] of bestApprox) {
          if (x < left[0])   left = [x, y];
          if (x > right[0])  right = [x, y];
          if (y < top[1])    top = [x, y];
          if (y > bottom[1]) bottom = [x, y];
        }

        const orderedExtremes = [left, right, top, bottom];
    // 5. Bounding-Box für den Rest deines Codes berechnen
    const xs = points.map(p => p[0]);
    const ys = points.map(p => p[1]);
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);

    return {
      extremes: orderedExtremes,
      width: maxX - minX,
      height: maxY - minY,
      minX: minX,
      minY: minY
    };

  } catch (e) {
    console.error("Fehler bei approxPolyDP, nutze Fallback:", e);
    return findAxisAlignedExtremes(points, false);
  }
}
  function getBoundingQuad(points) {
    const xs = points.map(p => p[0]);
    const ys = points.map(p => p[1]);
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    return {
      extremes: [
        [minX, minY],
        [maxX, minY],
        [maxX, maxY],
        [minX, maxY]
      ],
      width: maxX - minX,
      height: maxY - minY,
      minX: minX,
      minY: minY
    };
  }
  function getPointsFromSelector(selectorValue) {
    let points = selectorPointsCache.get(selectorValue);
    if (points) return points;

    if (selectorValue.includes("<path")) {
      const pathData = getPathDataFromSelector(selectorValue);
      if (!pathData) throw new Error("Pfad nicht gefunden");
      points = parsePathData(pathData);
    } else if (selectorValue.startsWith("xywh=pixel:") || selectorValue.includes("xywh=pixel:")) {
      const [, xywhString] = selectorValue.split("xywh=pixel:");
      const [x, y, w, h] = xywhString.split(",").map(n => parseFloat(n.trim()));
      points = [
        { x: x,     y: y },
        { x: x + w, y: y },
        { x: x + w, y: y + h },
        { x: x,     y: y + h }
      ];
    } else {
      points = [];
    }

    selectorPointsCache.set(selectorValue, points);
    return points;
  }

  function transformUntilInside(masterAnnoPoints, tgtPoints) {
    // 1. Iterativ skalieren
    let scaledSrc = masterAnnoPoints;
    let scale = 1.0;
    function scalePolygon(points, scaleFactor) {
      // Skaliere Punkte um das Zentrum
      const center = points.reduce(([sx, sy], [x, y]) => [sx + x, sy + y], [0, 0])
                    .map(val => val / points.length);
      return points.map(([x, y]) => [
        center[0] + (x - center[0]) * scaleFactor,
        center[1] + (y - center[1]) * scaleFactor
      ]);
    }
    while (!fitsInside(scaledSrc, tgtPoints) && scale > 0.01) {
      scale *= 0.98;
      scaledSrc = scalePolygon(masterAnnoPoints, scale);
    }
    return scale;
  }
  function warpAnnotationPoints(originalAnn, M) {
    const srcPts = cv.matFromArray(originalAnn.length, 1, cv.CV_32FC2,
      originalAnn.flatMap(([x, y]) => [x, y]) // <--- hier der Fix
    );

    const dstPts = new cv.Mat();
    cv.perspectiveTransform(srcPts, dstPts, M);

    // Ergebnis extrahieren
    const warpedAnn = [];
    for (let i = 0; i < originalAnn.length; i++) {
      warpedAnn.push({
        x: dstPts.data32F[i * 2],
        y: dstPts.data32F[i * 2 + 1]
    });
    }

    srcPts.delete();
    dstPts.delete();
    return warpedAnn;
  }
  function getPolygonFromSelector(selectorValue) {
    let polygon = selectorPolygonCache.get(selectorValue);
    if (!polygon) {
      polygon = [getPointsFromSelector(selectorValue).map(point => [point.x, point.y])];
      selectorPolygonCache.set(selectorValue, polygon);
    }
    return polygon;
  }

  function getMasterPolygon(depiction, masterW3c) {
    let masterPolygon = masterPolygonByDepictionId.get(depiction.depictionID);
    if (!masterPolygon) {
      masterPolygon = getPolygonFromSelector(masterW3c.target.selector.value);
      masterPolygonByDepictionId.set(depiction.depictionID, masterPolygon);
    }
    return masterPolygon;
  }

  function getImageTransformTargetPoints(imageTransform, textureWidth, textureHeight) {
    if (!imageTransform) return null;
    const transform = typeof imageTransform === "string" ? JSON.parse(imageTransform) : imageTransform;
    if (!transform || transform.type !== "quad" || !Array.isArray(transform.target) || transform.target.length !== 4) {
      return null;
    }
    const sourceWidth = transform.canvas?.width || textureWidth;
    const sourceHeight = transform.canvas?.height || textureHeight;
    return transform.target.map((point) => {
      if (transform.space === "uv") {
        return { x: point.u * textureWidth, y: point.v * textureHeight };
      }
      if (transform.space === "wall-pixel" && (sourceWidth !== textureWidth || sourceHeight !== textureHeight)) {
        return {
          x: (point.x / sourceWidth) * textureWidth,
          y: (point.y / sourceHeight) * textureHeight
        };
      }
      return { x: point.x, y: point.y };
    });
  }

  // iterate over all register-systems
  for (const dimension of dimensions) {
    // iterate over all registers
    for (const reg of dimension) {
      const regInfo = JSON.parse(reg.body[0].value)
      // if register is -1 --> register is empty, i. e. not existend in the cave --> skip. Those part of a register system do not need to be drawn
      if ((regInfo.Reg === "-1") && (regInfo.No === "-1")) continue
      let clipPathReg = getPointsFromSelector(reg.target.selector.value);
      if (clipPathReg.length === 0) {
        console.warn("Keine Annotation gefunden", reg);
      }
      const flipY = false;
      // convert to UV
      const clipPathRegUV = clipPathReg.map((regPoint) => {
        const u = regPoint.x / width;
        const v = flipY ? (1.0 - regPoint.y / height) : (regPoint.y / height);
        return {u: u, v: v};
      });
      registerPoints.push(clipPathRegUV)
      drawAnnoOutlineToTexture({progress: progress, w3cAnnotation: reg, textureCanvas: canvas });

      // get depiction infos
      const depictionInfos = regInfo.Depiction;
      if (colocodeReg) {
        if (depictionInfos && depictionInfos.length > 0) {
          const firsDepictionInfo = depictionInfos[0];
          if (firsDepictionInfo.depictionID === -1) {
            colocodeReg.push(0)
          } else {
            colocodeReg.push(1)
          }
        } else {
          colocodeReg.push(1)
        }
      }
      if (setRegisterShaderIndex){
        setRegisterShaderIndex(meshName, regInfo.dimensionId, regInfo.Reg, regInfo.No, registerPoints.length - 1)
      }
      if (depictionInfos[0]?.depictionID) {
        const depictionInfo = depictionInfos[0];
        if (putInDepictionShaderDic) putInDepictionShaderDic(depictionInfo, meshName, registerPoints.length - 1)
        // get actual depiction
        console.log("depictionInfo", depictionInfo)
        let depiction = relatedDepictionsById.get(depictionInfo.depictionID);
        try {
          if (depiction?.masterAnnotation) {

            const imageTransformTargetPoints = getImageTransformTargetPoints(depictionInfo.imageTransform, width, height);
            regInfo["hasMasterAnnotation"] = true
            reg.body[0].value = JSON.stringify(regInfo)
            const masterAnno = getAnnotationById(depiction, depiction.masterAnnotation);
            //get masterannotation
            const masterAnnoW3c = getParsedW3c(masterAnno);
            // get
            const svgPathString = masterAnnoW3c.target.selector.value;
            regInfo["masterAnnotationSelector"] = svgPathString;
            reg.body[0].value = JSON.stringify(regInfo)
            const masterAnnoPathData = getPathDataFromSelector(svgPathString);
            let masterPolygon = parsePathData(masterAnnoPathData);
            // we only need the part of the picture that is covered by the annotation and only in the size of the target. That reduces the computation time alot.
            const iiifUrl = buildOptimizedIIIFUrl({
              annotation: masterAnnoW3c,
              reg: reg,
              baseUrl: context + `/iiif/2/kucha%2Fimages%2F${masterAnno.image}`
            });
            const promise = loadIIIFImage(iiifUrl.url, sessionID).then((img) => {
              console.log("custom image loaded")
              let scale = 1
              //we crop the image to the size of the master annotation
              const annoCanvas = document.createElement("canvas");
              const annoCtx = annoCanvas.getContext("2d");

              annoCanvas.width = img.width;
              annoCanvas.height = img.height;
              annoCtx.drawImage(img, 0, 0);

              const scaledPath = new Path2D();
              // weed the master polygon in original size, to decide if the other annotations are in the master polygon. as we use it to crop the image, an annotation would be outside the image, if not fitted in the master polygon.
              const masterPolyForCheck = masterPolygon.map(p => [p.x, p.y]);
              // scale the points to the size of the cropped image
              masterPolygon = masterPolygon.map(p => ({
                x: (p.x - iiifUrl.cropBox.minX) * iiifUrl.scale,
                y: (p.y - iiifUrl.cropBox.minY) * iiifUrl.scale
              }));

              masterPolygon.forEach((p, i) => {
                if (i === 0) {
                  scaledPath.moveTo(p.x, p.y);
                } else {
                  scaledPath.lineTo(p.x, p.y);
                }
              });
              scaledPath.closePath();
              annoCtx.globalCompositeOperation = "destination-in";
              annoCtx.beginPath();
              annoCtx.fill(scaledPath);
              let xs
              let ys
              let customOffsetX = 0;
              let customOffsetY = 0;
              const hasCustomTransform = !!imageTransformTargetPoints;
              if (hasCustomTransform) {
                console.log("hasCustomTransform imageTransformTargetPoints",imageTransformTargetPoints)
              }
              // we now project the master annotation to the wall, using the register. As register can be a polygon or a rectangle, we need to check which one it is
              if (reg.target.selector.value.includes("<path") || imageTransformTargetPoints) {
                  // Polygon
                  const masterAnnoPoints = masterPolygon.map(p => [p.x, p.y ]);

                  const tgtPoints = hasCustomTransform ? imageTransformTargetPoints.map(p => [p.x, p.y]) : clipPathReg.map(p => [p.x, p.y]);
                  const isTriangle = !hasCustomTransform && tgtPoints[1][1] === tgtPoints[2][1]
                  const sourceExtremes = hasCustomTransform ? getBoundingQuad(masterAnnoPoints) : findQuadrilateralExtremes(masterAnnoPoints, isTriangle);
                  console.log("sourceExtremes",sourceExtremes)
                  const targetExtremes = hasCustomTransform ? getBoundingQuad(tgtPoints) : findAxisAlignedExtremes(tgtPoints, isTriangle);
                  const { extremes: masterAnnoPointsMax, width: widthSrc, height: heightSrc, minX: minXSrc, minY: minYSrc } = sourceExtremes;
                  const { extremes: tgtPointsMax, width: widthTgt, height: heightTgt, minX: minXTgt, minY: minYTgt } = targetExtremes;

                  const unscaledMasterAnnoPoints = masterAnnoPoints.map(([x, y]) => [
                    x - minXSrc,
                    y - minYSrc
                  ]);

                  const unscaledMasterAnnoPointsMax = masterAnnoPointsMax.map(([x, y]) => [
                    x - minXSrc,
                    y - minYSrc
                  ]);

                  const adjustedTgtPointsMax = (hasCustomTransform ? tgtPoints : tgtPointsMax).map(([x, y]) => [
                    x - minXTgt,
                    y - minYTgt
                  ]);
                  const adjustedTgtPoints = tgtPoints.map(([x, y]) => [
                    x - minXTgt,
                    y - minYTgt
                  ]);

                  const srcTri = cv.matFromArray(4, 1, cv.CV_32FC2, [].concat(...unscaledMasterAnnoPointsMax));
                  const dstTri = cv.matFromArray(4, 1, cv.CV_32FC2, [].concat(...adjustedTgtPointsMax));

                  // Sicherstellen, dass die Zielgröße echte Integer (Ganzzahlen) sind
                  const dsize = new cv.Size(Math.ceil(widthTgt), Math.ceil(heightTgt));

                  progress.step = "Anotation scalled, starting warping";
                  const M = cv.getPerspectiveTransform(srcTri, dstTri);
                  const warped = new cv.Mat();

                  const warpedAnnMat = warpAnnotationPoints(unscaledMasterAnnoPoints, M);
                  const srcMat = cv.imread(annoCanvas);


                  cv.warpPerspective(srcMat, warped, M, dsize, cv.INTER_LINEAR, cv.BORDER_CONSTANT, new cv.Scalar());
                  if (hasCustomTransform) {
                    scale = 1
                  } else {
                    scale = transformUntilInside(warpedAnnMat.map(p => [p.x, p.y]),adjustedTgtPoints);
                    scale = scale * 1.2
                  }
                  const registerOffsetX = Math.min(...tgtPoints.map(p=>p[0]));
                  const registerOffsetY = Math.min(...tgtPoints.map(p=>p[1]));
                  if (hasCustomTransform) {
                      customOffsetX = registerOffsetX;
                      customOffsetY = registerOffsetY;
                  }
                  var xsPiv = adjustedTgtPoints.map(p => p[0]);
                  var ysPiv = adjustedTgtPoints.map(p => p[1]);

                  const pivotX = Math.max(...xsPiv) * 0.5;
                  const pivotY = Math.max(...ysPiv) * 0.5;
                  for (const anotherAnno of depiction.relatedAnnotationList){
                    if (anotherAnno.annotoriousID === masterAnno.annotoriousID) continue
                    if (anotherAnno.image !== masterAnno.image) continue
                    var w3cAnno
                    try {
                      w3cAnno = getParsedW3c(anotherAnno)
                    } catch (error) {
                      console.error("anno for 3d error", anotherAnno, error)
                      continue
                    }

                    const anotherAnnoPolygon = getPolygonFromSelector(w3cAnno.target.selector.value);
                    if (fitsInside( anotherAnnoPolygon[0], masterPolyForCheck)){

                      const svgPathStringAnno = w3cAnno.target.selector.value;
                      const pathDataAnno = getPathDataFromSelector(svgPathStringAnno);
                      let clipPathAnno = parsePathData(pathDataAnno);
                      clipPathAnno = clipPathAnno.map(p => ({
                        x: (p.x - iiifUrl.cropBox.minX) * iiifUrl.scale,
                        y: (p.y - iiifUrl.cropBox.minY) * iiifUrl.scale
                      }));
                      const srcPointsAnno = clipPathAnno.map(p => [p.x, p.y ]);
                      const unscaledSrcPointsAnno = srcPointsAnno.map(([x, y]) => [
                        x - minXSrc,
                        y - minYSrc
                      ]);
                      const warpedAnnMatAnno = warpAnnotationPoints(unscaledSrcPointsAnno, M);
                      const clipPathRegUVAnno = warpedAnnMatAnno.map((p) => {
                        const x = hasCustomTransform ? registerOffsetX + p.x : registerOffsetX + pivotX + (p.x - pivotX) * scale;
                        const y = hasCustomTransform ? registerOffsetY + p.y : registerOffsetY + pivotY + (p.y - pivotY) * scale;
                        const u = x / width;
                        const v = flipY ? (1.0 - y / height) : (y / height);

                        return { u, v };
                      });

                      registerPoints.push(clipPathRegUVAnno)
                      if (colocodeReg) colocodeReg.push(1)
                      if (putInIcoDepictionShaderDic){
                        putInIcoDepictionShaderDic(wallNumber, registerPoints, depiction, anotherAnno)
                      }
                    }
                  }
                  annoCtx.clearRect(0, 0, annoCanvas.width, annoCanvas.height);
                  annoCanvas.width = widthTgt;
                  annoCanvas.height = heightTgt;
                  cv.imshow(annoCanvas, warped);
                  if (!hasCustomTransform) {
                      const srcBBox = [
                          [0, 0],
                          [widthSrc, 0], // Kein scaleDown mehr!
                          [widthSrc, heightSrc],
                          [0, heightSrc]
                      ];

                    // 2. Diese 4 Ecken jagen wir durch dieselbe Verzerrungs-Matrix (M).
                    // Da M hier noch nicht gelöscht wurde, funktioniert das fehlerfrei!
                    const warpedBBox = warpAnnotationPoints(srcBBox, M);

                    // 3. Wie gehabt Pivot und Scale für das Register anwenden
                    const generatedTargetPoints = warpedBBox.map(p => {
                      return {
                          x: registerOffsetX + pivotX + (p.x - pivotX) * scale,
                          y: registerOffsetY + pivotY + (p.y - pivotY) * scale
                      };
                    });

                    // Editor-konformes JSON für imageTransform erstellen
                    const generatedTransform = {
                        version: 1,
                        type: "quad",
                        space: "wall-pixel",
                        canvas: {
                            width: 3072,
                            height: 3072
                        },
                        target: generatedTargetPoints
                    };

                    // Im lokalen Modell überschreiben, damit der Editor zugreifen kann
                    depictionInfo.imageTransform = JSON.stringify(generatedTransform);
                    regInfo["Depiction"] = depictionInfos;
                    reg.body[0].value = JSON.stringify(regInfo);
                  }

                  srcMat.delete(); warped.delete(); srcTri.delete(); dstTri.delete(); M.delete();

                  xs = warpedAnnMat.map(p => p.x);
                  ys = warpedAnnMat.map(p => p.y);
                } else {
                  xs = masterPolygon.map(p => p.x);
                  ys = masterPolygon.map(p => p.y);
                  const minRegX = Math.min(...clipPathReg.map(p => p.x));
                  const minRegY = Math.min(...clipPathReg.map(p => p.y));
                  const minAnnoX = Math.min(...xs);
                  const minAnnoY = Math.min(...ys);
                  // Bounding Box des Registers
  // Bounding Box des Registers berechnen
                  const regW = Math.max(...clipPathReg.map(p => p.x)) - minRegX;
                  const regH = Math.max(...clipPathReg.map(p => p.y)) - minRegY;

                  // Skalierung strikt an die Höhe binden
                  scale = regH / annoCanvas.height;

                  // Zeichenbreite skaliert proportional (kann größer als regW werden)
                  const drawW = annoCanvas.width * scale;
                  const drawH = regH; // Entspricht annoCanvas.height * scale

                  // Zentrierung berechnen (erzeugt automatischen Überlauf in der Breite)
                  const centerOffsetX = (regW - drawW) / 2;
                  const centerOffsetY = 0; // Vertikal bleibt es bündig, da drawH == regH

                  // 🔥 Korrigiertes Offset inklusive Zentrierung
                  const registerOffsetX = minAnnoX + minRegX + centerOffsetX;
                  const registerOffsetY = minAnnoY + minRegY + centerOffsetY;

                  for (const anotherAnno of depiction.relatedAnnotationList){
                    if (anotherAnno.annotoriousID === masterAnno.annotoriousID) continue
                    if (anotherAnno.image !== masterAnno.image) continue
                    var w3cAnno
                    try {
                      w3cAnno = getParsedW3c(anotherAnno)
                    } catch (error) {
                      console.error(error)
                      continue
                    }
                    const anotherAnnoPolygon = getPolygonFromSelector(w3cAnno.target.selector.value);

                    if (fitsInside( anotherAnnoPolygon[0], masterPolygon[0])){
                      const svgPathStringAnno = w3cAnno.target.selector.value;
                      const pathDataAnno = getPathDataFromSelector(svgPathStringAnno);
                      let clipPathAnno = parsePathData(pathDataAnno);
                      clipPathAnno = clipPathAnno.map(p => ({
                        x: (p.x - iiifUrl.cropBox.minX) * iiifUrl.scale,
                        y: (p.y - iiifUrl.cropBox.minY) * iiifUrl.scale
                      }));
                      const srcPointsAnno = clipPathAnno.map(p => [p.x, p.y ]);

                      const clipPathRegUVAnno = srcPointsAnno.map((p) => {
                        const x = minRegX + centerOffsetX + (p[0] - minAnnoX) * scale;
                        const y = minRegY + (p[1] - minAnnoY) * scale;

                        const u = x / width;
                        const v = flipY ? (1.0 - y / height) : (y / height);

                        return { u, v };
                      });
                      registerPoints.push(clipPathRegUVAnno)
                      if (colocodeReg) colocodeReg.push(1)
                      if (putInIcoDepictionShaderDic) putInIcoDepictionShaderDic(wallNumber, registerPoints, depiction, anotherAnno)
                    }

                  }
                }
                const minX = Math.min(...xs);
                const maxX = Math.max(...xs);
                const minY = Math.min(...ys);
                const maxY = Math.max(...ys);
                const targetBox = { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
                const croppedCanvas = document.createElement("canvas");
                croppedCanvas.width = targetBox.w;
                croppedCanvas.height = targetBox.h
                const croppedCtx = croppedCanvas.getContext("2d");
                croppedCtx.drawImage(
                  annoCanvas,
                  targetBox.x, targetBox.y, targetBox.w, targetBox.h, // Quelle
                  0, 0, targetBox.w, targetBox.h                      // Ziel
                );
                let customTargetBox = null;
                console.log("customTargetBox hasCustomTransform", hasCustomTransform)
                if (hasCustomTransform) {
                    customTargetBox = {
                        x: customOffsetX + targetBox.x, // x-Wert innerhalb des Warps + globales Offset
                        y: customOffsetY + targetBox.y, // y-Wert innerhalb des Warps + globales Offset
                        w: targetBox.w,
                        h: targetBox.h
                    };
                    console.log("customTargetBox", customTargetBox)
                }
                // uncomment for downloading cropped images
                //downloadCanvas(croppedCanvas, `depiction_${depictionInfo.depictionID}_cropped.jpg`);
                if (croppedCanvas.width === 0 || croppedCanvas.height === 0) {
                  progress.current += 1;
                  return
                }
                wallImages.push({
                  depictionID: depictionInfo.depictionID,
                  image: croppedCanvas,
                  sourceImage: masterAnno.image,
                  register: reg
                });

                drawAnnoToTextureCanvas({
                  w3cAnnotation: reg,
                  textureCanvas: canvas,
                  annoCanvas: croppedCanvas,
                  scale: scale,
                  customTargetBox: customTargetBox
                });
                progress.current += 1;
            }).catch((e) => {
              console.log("error ", e)
              progress.current += 1;
            });
            promises.push(promise);
          } else {

            progress.current += 1;

          }
        } catch (error) {
          console.error(error);
          progress.current += 1;
        }
      }

    }
  }
  // Warten auf alle onload-Ereignisse
  await Promise.all(promises);
  // uncomment for downloading final images
  // downloadCanvas(canvas, `wall_${meshName}_final.jpg`);
}
function drawAnnoToTextureCanvas({ w3cAnnotation, textureCanvas, annoCanvas, scale, customTargetBox }) {
  const ctx = textureCanvas.getContext("2d");

  let clipPath = [];
  let targetBox;

  if (w3cAnnotation.target.selector.value.includes("xywh=pixel:")) {
    const [, xywhString] = w3cAnnotation.target.selector.value.split("xywh=pixel:");
    const [x, y, w, h] = xywhString.split(",").map(n => parseFloat(n.trim()));

    clipPath = [
      { x: x,     y: y },
      { x: x + w, y: y },
      { x: x + w, y: y + h },
      { x: x,     y: y + h }
    ];
    targetBox = { x, y, w, h };

  } else if (w3cAnnotation.target.selector.value.includes("<path")) {
    const pathMatch = w3cAnnotation.target.selector.value.match(/d="([^"]+)"/);
    if (!pathMatch) {
      console.error("Pfad nicht gefunden");
      return;
    }

    const pathData = pathMatch[1];
    clipPath = parsePathData(pathData);
    const xs = clipPath.map(p => p.x);
    const ys = clipPath.map(p => p.y);
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    targetBox = { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
  } else {
    console.warn("Unbekanntes Format");
    return;
  }
  let scaleX, scaleY, drawW, drawH, offsetX, offsetY;
  if (customTargetBox) {
    console.log("setting customTargetBox", customTargetBox)
      drawW = customTargetBox.w;
      drawH = customTargetBox.h;
      offsetX = customTargetBox.x;
      offsetY = customTargetBox.y;
    } else {
      if (w3cAnnotation.target.selector.value.includes("xywh=pixel:")) {
        // Nur nach der Höhe skalieren, damit sie immer komplett ausgefüllt wird
        const localScale = targetBox.h / annoCanvas.height;

        drawW = annoCanvas.width * localScale;
        drawH = annoCanvas.height * localScale;

        // Zentriert ausrichten. Ist das Bild breiter als die Box, wird
        // der offsetX-Wert automatisch negativ und das Bild läuft links und rechts über.
        offsetX = targetBox.x + (targetBox.w - drawW) / 2;
        offsetY = targetBox.y + (targetBox.h - drawH) / 2;
      } else {
        drawW = annoCanvas.width * scale;
        drawH = annoCanvas.height * scale;
        offsetX = targetBox.x + (targetBox.w - drawW) / 2;
        offsetY = targetBox.y + (targetBox.h - drawH) / 2;
      }

    }
  ctx.drawImage(annoCanvas, 0, 0, annoCanvas.width, annoCanvas.height, offsetX, offsetY, drawW, drawH);
  // 4. Danach den Umriss drüberzeichnen (ebenfalls skaliert)
  ctx.save();
  ctx.beginPath();
  clipPath.forEach((pt, i) => {
    const tx = pt.x;
    const ty = pt.y;
    if (i === 0) ctx.moveTo(tx, ty);
    else ctx.lineTo(tx, ty);
  });
  ctx.closePath();
  ctx.strokeStyle = "white";
  ctx.lineWidth = 3;
  ctx.stroke();
  ctx.restore();
  ctx.restore();
}

function drawAnnoOutlineToTexture({ progress, w3cAnnotation, textureCanvas }) {
  const ctx = textureCanvas.getContext("2d");

  let clipPath = [];
  let targetBox;

  if (w3cAnnotation.target.selector.value.includes("xywh=pixel:")) {
    const [, xywhString] = w3cAnnotation.target.selector.value.split("xywh=pixel:");
    const [x, y, w, h] = xywhString.split(",").map(n => parseFloat(n.trim()));

    clipPath = [
      { x: x,     y: y },
      { x: x + w, y: y },
      { x: x + w, y: y + h },
      { x: x,     y: y + h }
    ];
    targetBox = { x, y, w, h };

  } else if (w3cAnnotation.target.selector.value.includes("<path")) {
    const pathMatch = w3cAnnotation.target.selector.value.match(/d="([^"]+)"/);
    if (!pathMatch) {
      console.error("Pfad nicht gefunden");
      return;
    }

    const pathData = pathMatch[1];
    clipPath = parsePathData(pathData);
    const xs = clipPath.map(p => p.x);
    const ys = clipPath.map(p => p.y);
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    targetBox = { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
  } else {
    console.warn("Unbekanntes Format");
    return;
  }

  // Ränder zeichnen
  ctx.save();
  ctx.beginPath();
  clipPath.forEach((pt, i) => {
    if (i === 0) ctx.moveTo(pt.x, pt.y);
    else ctx.lineTo(pt.x, pt.y);
  });
  ctx.closePath();
  ctx.strokeStyle = "white";
  ctx.lineWidth = 10;
  ctx.stroke();
  ctx.restore();

  progress.step = "Annotation outline is integrated.";
}
function buildRegisterSVG(dimensions, getPointsFromSelector, width, height) {
  const svgNS = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNS, "svg");

  // Die ViewBox entspricht der exakten Canvas-Größe,
  // damit die Koordinaten der Pfade 1:1 passen.
  svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
  svg.setAttribute("width", "100%");
  svg.setAttribute("height", "100%");

  // Verhindert, dass das SVG Klicks blockiert (außer du willst Events an die Pfade hängen)
  svg.style.pointerEvents = "none";
  svg.style.position = "absolute";
  svg.style.top = "0";
  svg.style.left = "0";

  for (const dimension of dimensions) {
    for (const reg of dimension) {
      const regInfo = JSON.parse(reg.body[0].value);
      // Leere Register überspringen
      if (regInfo.Reg === "-1" && regInfo.No === "-1") continue;

      const clipPath = getPointsFromSelector(reg.target.selector.value);
      if (clipPath.length === 0) continue;

      // SVG Path-String (d-Attribut) zusammenbauen
      let d = "";
      clipPath.forEach((pt, i) => {
        d += (i === 0 ? "M " : "L ") + `${pt.x} ${pt.y} `;
      });
      d += "Z"; // Pfad schließen

      // Pfad-Element erzeugen
      const pathEl = document.createElementNS(svgNS, "path");
      pathEl.setAttribute("d", d);
      pathEl.setAttribute("fill", "none");
      pathEl.setAttribute("stroke", "white");
      pathEl.setAttribute("stroke-width", "10"); // Dein Wert für die Rahmen-Dicke

      // Optional: Metadaten ans SVG hängen, falls du Klick-Events für den Editor brauchst
      pathEl.dataset.dimensionId = regInfo.dimensionId;
      pathEl.dataset.reg = regInfo.Reg;
      pathEl.dataset.no = regInfo.No;

      svg.appendChild(pathEl);
    }
  }

  return svg;
}
const KuchaCommons = {
  createMap,
  parsePathData,
  parseSvgSelector,
  buildWallCanvas
};

// 1. Für GWT / JSNI (synchroner Browser-Import via <script src="...">)
if (typeof window !== 'undefined') {
  window.KuchaCommons = KuchaCommons;
}

// 2. Für Vue / Webpack / Vite (erlaubt sowohl Einzel-Imports als auch Default-Import)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    createMap,
    parsePathData,
    parseSvgSelector,
    buildWallCanvas,
    default: KuchaCommons
  };
}
